<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateProject"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :dialogName="resourceTitle"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="CreateProject"
      :id="formId"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetProjectGeneral
        :project="editor"
      >
      </FieldsetProjectGeneral>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Create'|pgettext('Button')"
      type="submit"
      :form="forms[formName]"
      :spinning="actions.create.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.create.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateProject extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: Boolean,
  })
  preventDefaultOnClose!: boolean;

  @Watch('preventDefaultOnClose')
  onPrevent_default_on_close(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("preventDefaultOnClose")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateProject')
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  resource!: any;

  async $$load_resource() {
    return new this.$fn.Resource(this.item)
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  container!: any;

  async $$load_container() {
    return {
      self: this.$fn.urlFor('create_project'),
      object: 'list',
      data: []
    }
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['item', 'formName', 'formId', 'resource', 'editor', 'container', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        formName: "project",
        formId: null,
        resource: null,
        editor: null,
        container: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("Project", "Project")
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Project", "New project"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5340_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5340, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_5346_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_5346, alias=undefined
    return {
      path: "item",
      value: this.editor.getData(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1040167445267876_closeComponent_5348_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_5348, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_5350_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_5350, alias=undefined
    return {
      location: {
        name: "app.project",
        params: {
          id: $event.data.response.data.id,
        }
        ,
      }
      ,
    }
  }

  async evh_1040167445267876_created_5349_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_created_5349, alias=undefined
    return !this.preventDefaultOnClose
  }

  async act_1040167445267876_reloadSlickgrid_5352_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_5352, alias=undefined
    return {
      grid: "projects",
    }
  }

  async evh_1040167445267876_created_5351_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_created_5351, alias=undefined
    return !this.preventDefaultOnClose
  }

  async act_1040167445267876_rest_5344_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_5344, alias=create
    return {
      method: "save",
      container: this.container,
      resource: this.editor,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5340: actions.CloseModalAction;
    evh_7315092382398562_close_5339: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_5342: actions.CloseModalAction;
    evh_2248226175642056_close_5341: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_setData_5346: actions.SetDataAction;
    evh_1040167445267876_before_5345: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_5348: actions.CloseComponentAction;
    evh_1040167445267876_created_5347: actions.EventHandlerImpl;
    act_1040167445267876_navigate_5350: actions.NavigateAction;
    evh_1040167445267876_created_5349: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_5352: actions.ReloadSlickgridAction;
    evh_1040167445267876_created_5351: actions.EventHandlerImpl;
    act_1040167445267876_rest_5344: actions.RestAction;
    evh_1040167445267876_submit_5343: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_5354: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_5353: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5340 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5340_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5339 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5340,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5339],
      }
    );
    const act_2248226175642056_closeModal_5342 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5341 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_5342,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5341],
      }
    );
    const act_1040167445267876_setData_5346 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_5346_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_before_5345 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_5346,
        event: "before",
        displayName: "setData",
      }
    );
    const act_1040167445267876_closeComponent_5348 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_5348_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_created_5347 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_5348,
        event: "created",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_navigate_5350 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_5350_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_created_5349 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_5350,
        event: "created",
        when: this.evh_1040167445267876_created_5349_getWhen,
        displayName: "navigate",
      }
    );
    const act_1040167445267876_reloadSlickgrid_5352 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_5352_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_created_5351 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_5352,
        event: "created",
        when: this.evh_1040167445267876_created_5351_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_rest_5344 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_5344_getActionArgs,
        displayName: "create",
        events: [evh_1040167445267876_before_5345, evh_1040167445267876_created_5347, evh_1040167445267876_created_5349, evh_1040167445267876_created_5351],
      }
    );
    const evh_1040167445267876_submit_5343 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_5344,
        event: "submit",
        displayName: "create",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5343],
      }
    );
    const act_1419464017721962_closeComponent_5354 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_5353 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_5354,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_5353],
      }
    );
    return {
      act_7315092382398562_closeModal_5340,
      evh_7315092382398562_close_5339,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_5342,
      evh_2248226175642056_close_5341,
      evh_2248226175642056_close,
      act_1040167445267876_setData_5346,
      evh_1040167445267876_before_5345,
      act_1040167445267876_closeComponent_5348,
      evh_1040167445267876_created_5347,
      act_1040167445267876_navigate_5350,
      evh_1040167445267876_created_5349,
      act_1040167445267876_reloadSlickgrid_5352,
      evh_1040167445267876_created_5351,
      act_1040167445267876_rest_5344,
      evh_1040167445267876_submit_5343,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_5354,
      evh_1419464017721962_clickPreventStop_5353,
      evh_1419464017721962_clickPreventStop,
      create: act_1040167445267876_rest_5344,
    }
  }
}

Vue.component("CreateProject", CreateProject);

</script>